import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {
    Col, Row, Button,
    Form, FormGroup, Label
} from 'reactstrap';
import { validateUserDetails } from './helper';
import Select from 'react-select';

class EndUserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            userUpdateFlag: false,
            activeUsers:[],
            corporateInactiveUsers:[],
            corporateList:[],
            selectedCorporate: null,
            companyDetails:[],
            selectDisableFlag:true,
            selectedCorporateAccessList:[],
            corporateAccessList:[]
        }
    }

    saveEndUserDetails(event) {
        event.preventDefault();
        if(this.props.endUserDetails.values.enabled !== false) {
            let msg = validateUserDetails(this.props.endUserDetails.values);
            if (msg === '') {
                this.props.endUserDetails.values.accessibleCorporates = this.getSelectedCorporateAccessIdArray();
                this.props.endUserDetails.values.canCreateCase = this.props.endUserDetails.values.canCreateCase === 'false' ? false : true;
                this.props.saveEndUserDetailsCallback(event, this.props.endUserDetails.values, this.state.userUpdateFlag);
                this.props.initialize({
                    contactNo: '', corporatetype: '', email: '', fullName: '', gender: '', id: '', userName: ''
                })
            }
            this.setState({
                errorMsg: msg,
                selectedCorporateAccessList:[]
            })
        } else {
            if (this.state.selectedCorporate) {
                let userResponse = window.confirm("Are you sure you want to transfer user from \"" + this.state.companyDetails[0].name + " to " + this.state.selectedCorporate.label + "\" !");
                if (userResponse) {
                    let msg = validateUserDetails(this.props.endUserDetails.values);
                    if (msg === '') {
                        this.props.endUserDetails.values.accessibleCorporates = this.getSelectedCorporateAccessIdArray();
                        this.props.endUserDetails.values.canCreateCase = this.props.endUserDetails.values.canCreateCase === 'false' ? false : true;
                        this.props.saveTransferedUserData(this.state.selectedCorporate, this.props.endUserDetails.values)
                    }else{
                        this.setState({
                            errorMsg: msg   
                        })
                    }
                }
            }
        }
        // this.setState({
        //     errorMsg: msg
        // })
        //this.props.endUserDetails.values = {contactNo:'',corporatetype:'',email:'',fullName:'',gender:'',id:'',userName:''}
    }

    resetEndUserDetails(event) {

        const { reset } = this.props;
        reset();
        this.setState({
            selectedCorporate:null,
            userUpdateFlag: false,
            selectDisableFlag:true,
            selectedCorporateAccessList:[]
        }, () => {
            this.props.resetEndUserDetailsCallback(event);
        })
        event.preventDefault();
    }

    loadUserDetails(e, obj) {
        let nameCorpIdArrayForLoad = this.loadSelectedAccessibleCorps(obj);
        this.setState({
            selectedCorporate:null,
            userUpdateFlag: true,
            selectDisableFlag:true,
            selectedCorporateAccessList: nameCorpIdArrayForLoad
        }, () => {
            this.props.loadUserDetailsCallback(e, {
                ...obj,
                canCreateCase: obj.canCreateCase === false ? 'false' : 'true'
            });
        });
    }

    loadInactiveUserDetails(e, obj) {
        let nameCorpIdArrayForLoad = this.loadSelectedAccessibleCorps(obj);
        this.setState({
            selectDisableFlag:false,
            selectedCorporateAccessList: nameCorpIdArrayForLoad
        }, () => {
            this.props.loadUserDetailsCallback(e, {
                ...obj,
                canCreateCase: obj.canCreateCase === false ? 'false' : 'true'
            });
        });
    }

    deleteUserDetails(e, obj) {
        this.setState({
            userUpdateFlag: true
        }, () => {
            this.props.deleteUserDetailsCallback(e, obj);
        });
    }

    addFieldsInactiveUsers(user) {
        for (let i = 0; i < user.length; i++) {
            user[i].password = ""
            user[i].id = user[i].id.toString()
            user[i].firstName = user[i].firstname
            user[i].lastName = user[i].lastname
        }
        this.state.corporateInactiveUsers.concat(user)
    }

    handleCorporateChange = (selectedData) => {
        this.setState({
            selectedCorporate: selectedData
        })
    }

    handleCorporateAccessListChange = (selectedData) => {
        this.setState({
            selectedCorporateAccessList: selectedData
        })
    }

    loadSelectedAccessibleCorps = (userObj) => {
        let nameCorpIdMapForLoad = [];
        if(userObj.accessibleCorporates && userObj.accessibleCorporates.length > 0) {
            for(let accessibleCorpId of userObj.accessibleCorporates) {
                if(this.props.corpIdNameMap.has(accessibleCorpId))
                    nameCorpIdMapForLoad.push({ label: this.props.corpIdNameMap.get(accessibleCorpId),
                                                value: accessibleCorpId});
            }
        }
        return nameCorpIdMapForLoad;
    }

    editCorporateList=(corporateList) =>{
        let corporateName = [];
        corporateList.forEach(item => {
            corporateName.push({ value: item.id, label: item.name })
        })
        this.setState({
            corporateList: corporateName,
        });
    }

    loadAccessibleCorpsOptions = () => {
        if(this.props.corpIdNameMap) {
            let accessibleCorporateArrayForLoad = []
            this.props.corpIdNameMap.forEach((value, key) => {
                accessibleCorporateArrayForLoad.push({label:value, value:key})
            });
            this.setState({
                corporateAccessList: accessibleCorporateArrayForLoad
            })
        }
    }

    getSelectedCorporateAccessIdArray = () => {
        let accessibleCorporates = [];
        this.state.selectedCorporateAccessList.forEach(elem => accessibleCorporates.push(elem.value))
        return accessibleCorporates;
    }
      
    componentDidMount(prevProps) {
        if(this.props.allUsers){
            this.setState({
                activeUsers:this.props.allUsers
            })
        }
        if(this.props.inactiveUsers){
            this.setState({
                corporateInactiveUsers:this.props.inactiveUsers
            })
        }
        if(this.props.corporateNames){
            this.editCorporateList(this.props.corporateNames)
        }
        
        this.loadAccessibleCorpsOptions();
        
    }

    componentDidUpdate(prevProps) {
        if(this.props.allUsers !== prevProps.allUsers && this.props.allUsers !== undefined){
            this.setState({
                activeUsers:this.props.allUsers
            })
        }    
        if (this.props.inactiveUsers !== prevProps.inactiveUsers) {
            this.setState({ corporateInactiveUsers: this.props.inactiveUsers })
        }
        if (!this.state.corporateInactiveUsers.message) {
            this.addFieldsInactiveUsers(this.state.corporateInactiveUsers)
        }
        if(this.props.treeData !== prevProps.treeData){
            this.setState({companyDetails:this.props.treeData})
        }
        if (prevProps.corporateNames !== this.props.corporateNames) {
            this.editCorporateList(this.props.corporateNames)
        }
        if (prevProps.corpIdNameMap !== this.props.corpIdNameMap) {
            this.loadAccessibleCorpsOptions();
        }


    }

    render() {
        let allUsersList = this.props.allUsers.map(userItem => {
            return (
                <li key={userItem.id}>
                    <Row key={userItem.id}>
                        <Col xs="12">
                            <Button size="sm" color="link" onClick={(event) => this.loadUserDetails(event, userItem)}>{userItem.firstName + ' ' + userItem.lastName}</Button>
                        </Col>
                        <Col xs="9" className="d-flex align-items-center pl-3 pr-1"><span>{userItem.permissionType === 'OWN' ? 'Access my reports' : 'Access all reports'}</span></Col>
                        <Col xs="0" className="text-right d-flex align-items-center p-0" onClick={(event) => this.deleteUserDetails(event, userItem)}><Button className="btn-transparent p-0 shadow-none"><i className="icon-close text-danger"></i></Button></Col>
                    </Row>
                </li>
            )
        })
        return (
            <div>
                <ul className="border-bottom mb-4">
                    {allUsersList}
                </ul>
                <Form>
                    {/* <FormGroup className="mb-4">
                        <Label for="userName">User Name<span className="text-danger">*</span></Label> */}
                    <Field name="userName" value="" component="input" type="hidden" />
                    {/* </FormGroup> */}
                    <FormGroup className="mb-4">
                        <Label for="firstName">First Name<span className="text-danger">*</span></Label>
                        <Field name="firstName" component="input" type="text" placeholder="Enter first name" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label for="lastName">Last Name<span className="text-danger">*</span></Label>
                        <Field name="lastName" component="input" type="text" placeholder="Enter last name" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label for="email">Email address<span className="text-danger">*</span></Label>
                        <Field name="email" component="input" type="text" placeholder="username@domain.com" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label for="contactNo">Contact<span className="text-danger">*</span></Label>
                        <Field name="contactNo" component="input" type="text" placeholder="9988775544" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="d-inline-flex mr-4 corporate-type ml-1" check>
                        <Label>
                            <Field className="input-type-radio" name="permissionType" component="input" type="radio" value='ALL' id="corporate-type-subsidiary" />
                            Access all Reports
                        </Label>
                    </FormGroup>
                    <FormGroup className="d-inline-flex corporate-type" check>

                        <Label>
                            <Field className="input-type-radio" name="permissionType" component="input" type="radio" value='OWN' id="corporate-type-subsidiary" />
                            Access my reports
                    </Label>
                    </FormGroup>
                    <FormGroup className="d-inline-flex corporate-type" check>
                        <Label>
                            <Field className="input-type-radio" name="permissionType" component="input" type="radio" value='SPECIFIC' id="corporate-type-subsidiary" />
                            Specific
                    </Label>
                    </FormGroup>
                    <FormGroup className="d-inline-flex corporate-type" check>
                        <Label>
                            <Field className="input-type-radio" name="permissionType" component="input" type="radio" value='DIVISION' id="corporate-type-subsidiary" />
                            Division
                    </Label>
                    </FormGroup>
                    <FormGroup>
                        <Label>Access Corporate Reports</Label>
                        <Select 
                        // isDisabled={this.state.selectDisableFlag}
                        value={this.state.selectedCorporateAccessList}
                        onChange={this.handleCorporateAccessListChange}
                        options={this.state.corporateAccessList}
                        isMulti={true}
                        >
                        </Select>
                    </FormGroup>
                    <FormGroup className="mb-3 mt-2">
                        <Label>Is case creation allowed</Label>
                        <div>
                            <FormGroup className="d-inline-flex corporate-type mr-4" check>
                                <Label>
                                    <Field className="input-type-radio" name="canCreateCase" component="input" type="radio" value='true' />
                                    Yes
                                </Label>
                            </FormGroup>
                            <FormGroup className="d-inline-flex corporate-type" check>
                                <Label>
                                    <Field className="input-type-radio" name="canCreateCase" component="input" type="radio" value='false' />
                                    No
                                </Label>
                            </FormGroup>
                        </div>
                    </FormGroup>
                    <FormGroup className="d-flex justify-content-end">
                        <Button type="submit" className="mr-3" color="primary" onClick={(event) => this.saveEndUserDetails(event)}>Save</Button>
                        <Button type="submit" className="" color="primary" onClick={(event) => this.resetEndUserDetails(event)}>Reset</Button>
                    </FormGroup>
                    <div className='error'>{this.state.errorMsg}</div>
                </Form>
            </div>
        )
    }
}

EndUserDetails = reduxForm({
    form: 'endUserDetailsForm',
    enableReinitialize: true
})(EndUserDetails)


const mapStateToProps = (state, ownProps) => ({
    endUserDetails: state.form.endUserDetailsForm,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default EndUserDetails = connect(
    mapStateToProps,
    mapDispatchToProps
)(EndUserDetails)